export default __webpack_public_path__ + "static/media/gallery_01.9d55ff68.jpg";